export { renderAvatar_unstable as renderAvatar } from '@fluentui/react-avatar';
